export default "/images/Equine.svg?fa7a57fa90fcbf5bc35c78885b49fcde";